<div style="display: flex;align-items: center;justify-content: space-between;padding: .5rem; color:#545454;overflow: auto;"
    [style.height]="desktopTemplate? 'max-content' : '40px'">
    <span multilang [style.font-size]="desktopTemplate? '1.4rem' : '1rem'">Termin bei <span
            style="font-weight: 500 !important;">{{termindate?.mitarbeiter?.firstname + ' ' +
            termindate?.mitarbeiter?.lastname}}</span>
        vereinbaren</span>
    <span multilang style="font-size: 1.5rem;transform: translate(2px, 5px);" class="clicable" (click)="onNoClick()">
        <mat-icon>close</mat-icon>
    </span>
</div>

<mat-divider></mat-divider>

<div style="display: flex;padding: .5rem;flex-direction: column;color:#545454;overflow: auto;"
    [style.height]="desktopTemplate? 'max-content' : 'calc(100% - 130px'">
    <form [formGroup]="terminform">
        <div style="display: flex;align-items: center;">
            <mat-icon>date_range</mat-icon>
            <mat-label style="font-weight: 500 !important;font-size: 1.2rem;">Termin <span multilang
                    style="font-size: .8rem;">am
                    {{termindate?.day | date}} um {{termindate?.time?.startTime}} Uhr in
                    {{termindate?.office?.name}}</span></mat-label>
        </div>
        <mat-divider></mat-divider>
        <div style="display: flex;margin-top: .5rem;flex-direction: column;">
            <mat-form-field appearance="fill">
                <mat-label>Thema</mat-label>
                <mat-select placeholder="Thema" formControlName="thema" name="thema" required cdkFocusInitial>
                    <mat-option [value]="th.code" *ngFor="let th of themas">{{th.name}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill">
                <mat-label>Art</mat-label>
                <mat-select placeholder="art" formControlName="art" name="art" required>
                    <mat-option [value]="art.code" *ngFor="let art of arts">{{art.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div style="display: flex;align-items: center;">
            <mat-icon>person</mat-icon>
            <mat-label style="font-weight: 500 !important;font-size: 1.2rem;">Kunde</mat-label>
        </div>
        <mat-divider></mat-divider>
        <ng-container *ngTemplateOutlet="desktopTemplate ? deskmode: mobilemode"></ng-container>
        <ng-template #deskmode>
            <div style="display: flex;margin-top: .5rem;flex-direction: column;">
                <!--Anrede-->
                <div style="display: flex;  padding: .5rem 0;flex-direction: column;">
                    <div>
                        <mat-button-toggle-group formControlName="salutation" name="salutation"
                            [style.border-color]="!terminform.controls['salutation'].valid && terminform.controls['salutation'].touched ? 'red' : ''">
                            <mat-button-toggle multilang value="Herr">Herr</mat-button-toggle>
                            <mat-button-toggle multilang value="Frau">Frau</mat-button-toggle>
                        </mat-button-toggle-group>
                        <span multilang style="margin-left: .5rem;">*</span>
                    </div>
                </div>
                <!--end Anrede-->
                <div style="display: flex;">
                    <div style="display: flex;flex-direction: column;width: 50%">
                        <mat-form-field appearance="fill">
                            <mat-label>Vorname</mat-label>
                            <input matInput type="text" placeholder="Vorname" formControlName="firstname"
                                name="firstname" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Nachname</mat-label>
                            <input matInput type="text" placeholder="Nachname" formControlName="lastname"
                                name="lastname" required>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Email</mat-label>
                            <input matInput type="email" placeholder="Email" formControlName="email" name="email"
                                required>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Telefon</mat-label>
                            <input matInput type="tel" placeholder="Telefon" formControlName="tel" name="tel" required>
                        </mat-form-field>
                    </div>

                    <div style="display: flex;flex-direction: column;width: 50%;margin-left: .3rem;">
                        <mat-form-field appearance="fill">
                            <mat-label>Notiz</mat-label>
                            <textarea rows="10" matInput formControlName="notiz" name="notiz"></textarea>
                        </mat-form-field>
                        <!--re-captcha formControlName="captcha" name="captcha" required [siteKey]="sitekey"
                            (error)="recaptchaHandleError($event)" #captchaElem></re-captcha-->
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #mobilemode>
            <!--Anrede-->
            <div style="display: flex;  padding: .5rem 0;flex-direction: column;">
                <div>
                    <mat-button-toggle-group formControlName="salutation" name="salutation"
                        [style.border-color]="!terminform.controls['salutation'].valid && terminform.controls['salutation'].touched ? 'red' : ''">
                        <mat-button-toggle multilang value="Herr">Herr</mat-button-toggle>
                        <mat-button-toggle multilang value="Frau">Frau</mat-button-toggle>
                    </mat-button-toggle-group>
                    <span multilang style="margin-left: .5rem;">*</span>
                </div>
            </div>
            <div style="display: flex;margin-top: .5rem;">
                <div style="display: flex;flex-direction: column;width: 100%">
                    <mat-form-field appearance="fill">
                        <mat-label>Vorname</mat-label>
                        <input matInput type="text" placeholder="Vorname" formControlName="firstname" name="firstname"
                            required>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Nachname</mat-label>
                        <input matInput type="text" placeholder="Nachname" formControlName="lastname" name="lastname"
                            required>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" placeholder="Email" formControlName="email" name="email" required>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input matInput type="tel" placeholder="Telefon" formControlName="tel" name="tel" required>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                        <mat-label>Notiz</mat-label>
                        <textarea rows="10" matInput formControlName="notiz" name="notiz"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </ng-template>
    </form>
</div>
<mat-divider></mat-divider>
<div style="display: flex;padding: .5rem;justify-content: flex-end;">
    <button mat-button (click)="onNoClick()">Abbrechen</button>
    <button mat-flat-button color="primary" (click)="registrierenF()">Termin
        vereinbaren</button>
</div>